import { VoiceBoard } from './VoiceBoard';

/** 현장 › 아차사고일지 — 근로자가 현장 QR 로 낸 아차사고(V576 · DOC-136). */
export function SiteNearMissPage({ siteId }: { siteId: string }) {
  return <VoiceBoard siteId={siteId} kind="NEAR_MISS" title="아차사고일지" />;
}
